import { getRelativeFontSize, boldFont, PrimaryTextColor, regularFont } from '../../../../../utils/styles';

const PersonalDetailsStyles = {
  personalWrapper: {
    margin: "0 5%",
  },
  pageInfoHeader: {
    // position: 'absolute',
    // left: '130px',
    // top: '30px',
  },

  Heading: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
  },
  SubHeading: {
    ...boldFont,
    fontSize: getRelativeFontSize(2),
  },
  text: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },

  header: {
    paddingBottom: '30px ',
    marginTop: 5,
  },
  pageHeading: {
    fontSize: getRelativeFontSize(2),
    ...boldFont,
    color: PrimaryTextColor,
  },
  pageText: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },
  avtarStyle: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    border: '4px solid #ECEDFC',
    //  overflow: "hidden",
    padding: '5px',
    position: ' relative',
    '& img': {
      width: '100%',
      height: ' auto',
      overflow: 'hide',
    },
  },

  uploadIcon: {
    position: ' absolute',
    bottom: '-15px',
    right: '-10px',
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    background: '#ECEDFC',
  },
  custombuttonStyle: {
    width: '200px',
  },
  labelHead:{
    display:"flex",
    flexDirection:"column"
  },
  label: {
    ...regularFont,
    fontSize: getRelativeFontSize(),
    wordSpacing: '2px',
    color: PrimaryTextColor,
    margin:"5px 0 3px",
  },

  autocomplateStyle: {
    width: '100%',
    background: '#fff',

    '& .MuiInputBase-input':{
      padding: '4px 5px !important',
    },
    '& .MuiOutlinedInput-root': {
      padding: '4px 9px',
      borderRadius: '4px',
      '&.Mui-focused fieldset': {
        borderColor: '#E7E7EA',
      },
    },
    '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7E7EA',
    },
  },

  avatarContainer: {
    position: 'relative',
    width: 70,
    height: 70,
    borderRadius: '50%',
    border: '4px solid #ECEDFC',
    overflow: 'hidden',
    padding: '5px',
  },
  cameraIcon: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    transform: 'translate(25%, 40%)',
    // backgroundColor: theme.palette.common.white,
    borderRadius: '50%',
    padding: 4,
    cursor: 'pointer',
    zIndex: 2,
    width: '20px',
    height: '20px',
  },
  fileInput: {
    display: 'none',
  },

  profileContainer: {
    position: 'relative',
    zIndex: 9,
    width: '100px',
  },
  profile: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    overflow: 'hidden',
    zIndex: 9,
    border: '4px solid #ECEDFC',
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',

    '& img': {
      width: '100%',
      height: 'auto',
    },
  },
  uploadCameraIcon: {
    position: 'absolute',
    bottom: '-9px',
    right: '10px',
    zIndex: 9999,
    background: '#ECEDFC',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      height: '10px',
      width: '10px',
    },
  },

  autoInputBlank: {
    '& .MuiFormHelperText-root.Mui-error': {
      color: '#d32f2f',
      fontSize: getRelativeFontSize(),
      ...regularFont,
      marginLeft: '5px',
      marginBottom: '5px',
    },
    '& .MuiAutocomplete-input': {
      fontSize: getRelativeFontSize(),
      padding:"4px 5px",
    },
  },

  autoInputFill: {
    '& .MuiFormHelperText-root.Mui-error': {
      color: '#d32f2f',
      fontSize: getRelativeFontSize(),
      ...regularFont,
      marginLeft: '5px',
      marginBottom: '5px',
    },
    '& .MuiAutocomplete-inputFocused': {
      fontSize: getRelativeFontSize(2),
    },
  },
  buttonWrapper: {
    display: "flex",
    gap  :"50px",
    marginTop  :"50px"
  },
};

export default PersonalDetailsStyles;
